import React from 'react';
import styled from 'styled-components';
import { Stars } from './stars';

export interface MarkStarsProps {
  rating: number;
  max: number;
  className?: string;
}

const Mark = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
`;

const WrapperStars = styled.div`
  display: flex;
  gap: 2px;
`;

const MarkText = styled.span`
  align-items: center;
  color: var(--text-color-alt);
  display: flex;
  gap: 6px;
  line-height: 1.38;
`;

const MarkTextValue = styled.span`
  font-family: var(--theme-typography-primary-font);
  font-size: 48px;
  font-weight: 700;

  &.mod-dark {
    color: var(--text-color);
  }

  &.mod-light {
    color: var(--theme-color-medium);
  }
`;

const MarkTextTotal = styled.span`
  color: var(--text-color-alt);
  font-size: 16px;
`;

export const MarkStars = (props: MarkStarsProps) => {
  const { rating, max, className } = props;

  return (
    <Mark>
      <MarkText>
        <MarkTextValue className={className}>{rating}</MarkTextValue>
        <MarkTextTotal> / 10</MarkTextTotal>
      </MarkText>
      <WrapperStars>
        <Stars rating={rating / 2} max={max / 2} />
      </WrapperStars>
    </Mark>
  );
};
